import React from "react";
import MBCTimage from "../../../assets/mindfullCBT.png";
import {
  Diagram3,
  ClockHistory,
  CalendarCheck,
  People,
  Lightbulb,
  Check2
} from "react-bootstrap-icons";

function TherapyIcon({ name }) {
  if (name === "brain") return <Diagram3 className="therapy-icon" />;
  if (name === "history") return <ClockHistory className="therapy-icon" />;
  if (name === "today") return <CalendarCheck className="therapy-icon" />;
  if (name === "sessions") return <People className="therapy-icon" />;
  if (name === "idea") return <Lightbulb className="therapy-icon" />;
  return null;
}

function CheckIcon() {
  return <Check2 className="therapy-check" />;
}

export default function MindfulnessModal({ setShow }) {
  return (
    <>
      <div className="therapy-modal-backdrop" onClick={() => setShow(false)} />

      <div className="modal fade show d-block therapy-modal-wrap" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog modal-dialog-centered modal-lg therapy-modal-dialog">
          <div className="modal-content therapy-modal-content">
            <div className="therapy-modal-hero">
              <div className="therapy-modal-hero-inner text-center">
                <img
                  src={MBCTimage}
                  className="img-fluid mx-auto d-block mb-3"
                  alt="Mindfulness Based CBT"
                />

                <h5 className="therapy-modal-title">What is Mindfulness Based CBT</h5>

                <div className="therapy-modal-subtitle">
                  Mindfulness Based Cognitive Therapy explained
                </div>
              </div>

              <button
                type="button"
                className="btn-close therapy-modal-close"
                onClick={() => setShow(false)}
                aria-label="Close"
              />
            </div>

            <div className="modal-body therapy-modal-body">
              <div className="therapy-modal-card">
                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="brain" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Mindfulness Based Cognitive Therapy
                    </div>
                    <div className="therapy-modal-item-text">
                      Mindfulness Based Cognitive Therapy (MBCT) is designed to help people who suffer repeated
                      bouts of depression and chronic unhappiness. However it works for anyone who is struggling
                      to keep up with the pace of the modern world.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="history" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Where MBCT Comes From
                    </div>
                    <div className="therapy-modal-item-text">
                      It combines the ideas of cognitive therapy with meditative practices and attitudes based on
                      the cultivation of mindfulness. MBCT was developed by Zindel Segal, Mark Williams and John
                      Teasdale, based on Jon Kabat Zinn’s Mindfulness Based Stress Reduction program.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="today" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      What It Helps With
                    </div>
                    <div className="therapy-modal-item-text">
                      The heart of this work lies in becoming acquainted with the modes of mind that often
                      characterize mood disorders while simultaneously learning to develop a new relationship to them.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="sessions" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Evidence and Relapse Prevention
                    </div>
                    <div className="therapy-modal-item-text">
                      The UK National Institute of Clinical Excellence (NICE) has endorsed MBCT as an effective
                      treatment for prevention of relapse. Research has shown that people who have been clinically
                      depressed 3 or more times find that learning these skills helps reduce the chances that
                      depression will return.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-callout">
                  <div className="therapy-modal-callout-icon">
                    <TherapyIcon name="idea" />
                  </div>
                  <div className="therapy-modal-callout-text">
                    <span className="therapy-modal-callout-strong">
                      Clinical trials indicate
                    </span>{" "}
                    MBCT reduces rates of relapse by around 50 percent among patients who suffer from recurrent depression.
                  </div>
                </div>

                <div className="therapy-modal-split">
                  <div className="therapy-modal-split-left">
                    <div className="therapy-modal-item-title mb-2">
                      MBCT supports people to
                    </div>

                    <div className="therapy-modal-checklist">
                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Notice thoughts and feelings earlier
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Step back from unhelpful thinking patterns
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Build mindfulness skills that support everyday life
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Develop a new relationship with difficult moods
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="therapy-modal-split-right">
                    <div className="therapy-modal-note">
                      Kuyken et al. (2008)
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer therapy-modal-footer">
              <button
                className="btn btn-brand-white fw-semibold therapy-modal-footer-btn"
                onClick={() => setShow(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
